export function trimZeroesLeft(string) {
  return string.replace(/^0+/, '')
}
